import React, { useMemo, useRef } from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Line } from 'react-chartjs-2'
import { CategoryScale, Chart, LinearScale, LineElement, PointElement, TimeScale } from 'chart.js'


function ProcessChart({ className }) {

  const {
    ambientTemp, setAmbientTemp,
    heatTime, setHeatTime,
    holdTime, setHoldTime,
    processTemp, setProcessTemp,
    processTime
  } = ComponentData()

  Chart.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
  )

  const getGradient = (ctx, chartArea) => {
    let gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    gradient.addColorStop(0, '#0000ff')
    gradient.addColorStop(0.5, '#ffff00')
    gradient.addColorStop(1, '#ff0000')
    return gradient
  }

  const data = useMemo(() => {
    return {
      labels: [0, heatTime, processTime, processTime + heatTime],
      datasets: [
        {
          borderColor: (context) => {
            const chart = context.chart;
            const { ctx, chartArea } = chart;
            if (!chartArea) return;
            return getGradient(ctx, chartArea)
          },
          label: 'Temperatur',
          data: [ambientTemp, processTemp, processTemp, ambientTemp]
        }
      ],
    }
  }, [ambientTemp, heatTime, processTemp, processTime])

  const options = {
    scales: {
      x: {
        type: 'linear',
        title: {
          display: true,
          text: 'Zeit in Minuten'
        },
        max: processTime + heatTime
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Temperatur in °C'
        },
        max: processTemp >= 250 ? 400 : 250,
      },
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
      datalabels: {
        display: false
      }
    },
    heatPhase: heatTime,
    processPhase: processTime
  }


  const backgroundColorPlugin = {
    id: 'backgroundColorPlugin',
    beforeDraw(chart) {
      const { ctx, chartArea: { top, bottom, right }, scales: { x } } = chart
      const bgColors = (low, high, color) => {
        ctx.fillStyle = color
        ctx.fillRect(x.getPixelForValue(low), top, x.getPixelForValue(high) - x.getPixelForValue(low), bottom - top)
      }
      bgColors(0, chart.config.options.heatPhase, 'rgba(245,246,229,1)')
      bgColors(chart.config.options.heatPhase, chart.config.options.processPhase, 'rgba(229,232,236,1)')
      bgColors(chart.config.options.processPhase, right, 'rgba(245,246,229,1)')
    }
  }

  return (
    <div className={className}>
      <div className="chart">
        <Line id='process-chart' options={options} data={data} plugins={[backgroundColorPlugin]} height={70} />
        <div className="configuration-area">
          <div id="starttemp" className="absolute-box">
            <label>Starttemperatur:</label>
            <input type="number" value={ambientTemp} onChange={(e) => {
              if (e.target.value === '') {
                setAmbientTemp(e.target.value)
              } else if (e.target.value >= 0 && e.target.value <= 45) {
                setAmbientTemp(e.target.valueAsNumber)
              }
            }} />
          </div>
          <div id="processtemp" className="absolute-box">
            <label>Prozesstemperatur:</label>
            <input type="number" value={processTemp} onChange={(e) => {
              if (e.target.value === '') {
                setProcessTemp(e.target.value)
              } else if (e.target.value >= 0 && e.target.value <= 450) {
                setProcessTemp(e.target.valueAsNumber)
              }
            }} />
          </div>
          <div id="heattime" className="absolute-box">
            <label>Dauer Aufheizphase:</label>
            <input type="number" value={heatTime} onChange={(e) => {
              if (e.target.value === '') {
                setHeatTime(e.target.value)
              } else if (e.target.value >= 0) {
                setHeatTime(e.target.valueAsNumber)
              }
            }} />
          </div>
          <div id="processtime" className="absolute-box">
            <label>Dauer Prozessphase:</label>
            <input type="number" value={holdTime} onChange={(e) => {
              if (e.target.value === '') {
                setHoldTime(e.target.value)
              } else if (e.target.value >= 0) {
                setHoldTime(e.target.valueAsNumber)
              }
            }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProcessChart